export default function getTokenBearer() {
    const isSSO = true;
    return isSSO ? 'Bearer' : 'Token';
  }
